/* Polsk katalog for locale-no.js (del 2 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'fi.recheck': 'Potwierdziłem',
  'fi.stillUnverified': 'Adres nadal nie jest potwierdzony. Sprawdź skrzynkę odbiorczą i folder spamu.',
  'fi.decline': 'Odrzuć',
  'fi.declined': 'Zaproszenie zostało odrzucone.',
  'set.firm.title': 'Biuro rachunkowe',
  'set.firm.sub': 'Biuro otrzymuje dostęp do ksiąg dopiero po Twojej akceptacji i traci go w momencie zakończenia współpracy.',
  'set.firm.none': 'Żadne biuro rachunkowe nie ma dostępu do tej firmy i żadne o niego nie prosiło.',
  'set.firm.pending': 'Czeka na Twoją odpowiedź',
  'set.firm.active': 'Ma dostęp',
  'set.firm.end': 'Zakończ współpracę',
  'set.firm.endConfirm': 'Zakończyć współpracę z {firm}? Współpracownicy natychmiast stracą dostęp do ksiąg.',
  'set.firm.ended': 'Współpraca została zakończona, a dostęp cofnięty.',
  'set.firm.onlyManagers': 'Tylko właściciel i administratorzy mogą odpowiedzieć na prośbę.',
  'rf.create.title': 'Utwórz biuro rachunkowe',
  'rf.create.eyebrow': 'Biuro rachunkowe',
  'rf.create.readyBody': 'Biuro zostało utworzone, a Ty jesteś jego właścicielem. Następny krok to zaproszenie współpracowników i powiązanie klientów.',
  'rf.create.openSurface': 'Otwórz panel biura',
  'rf.create.body': 'Biuro jest pobierane z Enhetsregisteret. Zostaniesz właścicielem i potem możesz zapraszać współpracowników.',
  'rf.create.orgNumber': 'Numer organizacyjny',
  'rf.create.hintDigits': 'Dziewięć cyfr. Biuro musi być zarejestrowane w Enhetsregisteret.',
  'rf.create.hintReady': 'Numer zostanie sprawdzony w Enhetsregisteret podczas tworzenia.',
  'rf.create.hintDemo': 'Konto demonstracyjne może używać zmyślonego numeru. Nadaj biuru nazwę poniżej.',
  'rf.create.firmName': 'Nazwa biura',
  'rf.create.nameRequired': 'Nie znaleziono firmy w Enhetsregisteret. Wpisz nazwę biura, aby kontynuować.',
  'rf.create.unverifiedNote': 'Biuro zostanie utworzone bez sprawdzenia w rejestrze i oznaczone jako niezweryfikowane. Musi zostać zweryfikowane, zanim prawdziwe biura zaczną z niego korzystać.',
  'rf.create.demoNote': 'Konto demonstracyjne samo ustala nazwę. Zwykłe konta otrzymują nazwę z Enhetsregisteret.',
  'rf.create.submit': 'Utwórz biuro',
  'rf.create.working': 'Tworzenie …',
  'rf.create.done': 'Biuro rachunkowe zostało utworzone',
  'rf.create.note': 'Sprawdzenie potwierdza, że firma istnieje. Nie weryfikuje, czy możesz działać w jej imieniu.',
  'rf.member.title': 'Stanowisko',
  'rf.member.email': 'E-mail',
  'rf.member.person': 'Osoba',
  'rf.member.rights': 'Uprawnienia',
  'rf.member.inviteTitle': 'Zaproś współpracownika',
  'rf.member.invite': 'Wyślij zaproszenie',
  'rf.member.inviting': 'Wysyłanie …',
  'rf.member.invited': 'Zaproszenie wysłane',
  'rf.member.inviteMailFailed': 'Zaproszenie zostało utworzone, ale nie udało się wysłać e-maila.',
  'rf.member.listTitle': 'Współpracownicy',
  'rf.member.none': 'Brak jeszcze współpracowników.',
  'rf.member.updated': 'Stanowisko zostało zmienione',
  'rf.member.remove': 'Usuń dostęp',
  'rf.member.removed': 'Dostęp został usunięty',
  'rf.member.removedWithClients': 'Dostęp został usunięty, także u klientów (liczba: {count}).',
  'rf.member.removeConfirm': 'Usunąć dostęp dla {name}? Cały dostęp do klientów, który biuro przyznało tej osobie, zostanie jednocześnie cofnięty.',
  'rf.member.removeNote': 'Gdy usuniesz współpracownika, cofnięty zostanie też cały dostęp do klientów, który biuro mu przyznało — u wszystkich klientów, w jednej operacji.',
  'rf.member.ownerRights': 'Właściciel biura',
  'rf.member.canControl': 'Może kontrolować',
  'rf.nav.backToApp': 'Do moich ksiąg',
  'rf.nav.back': 'Wstecz',
  'app.nobusiness.openFirm': 'Otwórz biuro rachunkowe',
  'rf.tab.close': 'Zamknij kartę',
  'rf.tab.assignFirst': 'Nikt nie został jeszcze przypisany do zlecenia tego klienta. Dostęp do ksiąg wynika z przypisania — przypisz kogoś do zlecenia w sekcji Klienci.',
  'rf.tab.assignNeeded': 'Nie jesteś przypisany do zlecenia tego klienta. Poproś administratora biura, aby Cię przypisał.',
  'rf.soon.clients': 'Przegląd klientów jest właśnie łączony ze statusem klienta, który backend oblicza dla każdego klienta.',
  'rf.soon.reconciliation': 'Panel uzgodnień jest w budowie. Model dostępu i status klienta, na których się opiera, są już gotowe.',
  'rf.soon.control': 'Panel kontroli pojawi się po uzgodnieniach. Zasada czterech oczu będzie egzekwowana w backendzie od momentu uruchomienia.',
  'rf.noFirm.title': 'Nie jesteś członkiem biura rachunkowego',
  'rf.noFirm.body': 'Nie jesteś jeszcze członkiem żadnego biura. Utwórz własne poniżej lub poproś administratora biura o zaproszenie — zaproszenie przyjdzie e-mailem.',
  'tc.title': 'Czat zespołu',
  'tc.rooms': 'Pokoje',
  'tc.dms': 'Wiadomości bezpośrednie',
  'tc.newRoom': 'Nowy pokój',
  'tc.roomName': 'Nazwa pokoju',
  'tc.roomNamePlaceholder': 'Np. Zespół kontroli',
  'tc.createRoom': 'Utwórz pokój',
  'tc.noColleagues': 'Brak jeszcze innych osób w biurze',
  'tc.commonRoom': 'Pokój wspólny',
  'tc.room': 'Pokój',
  'tc.commonSubtitle': 'Wspólny pokój dla całego zespołu',
  'tc.roomSubtitle': 'Pokój w biurze',
  'tc.dm': 'Wiadomość bezpośrednia',
  'tc.dmSubtitle': 'Wiadomość bezpośrednia',
  'tc.empty': 'Brak jeszcze wiadomości — napisz pierwszą.',
  'tc.placeholder': 'Napisz wiadomość…',
  'tc.send': 'Wyślij',
  'tc.unknown': 'Nieznany',
  'shell.client.clients': 'Twoi klienci',
  'shell.client.signOutSub': 'Zakończ sesję na tym urządzeniu',
  'shell.client.signOutFailed': 'Nie udało się wylogować. Spróbuj ponownie.',
  'shell.client.none': 'Brak firmy',
  'shell.client.noBusinesses': 'Brak firm',
  'shell.client.connecting': 'Łączenie z backendem Plumme',
  'shell.client.personalEconomy': 'Finanse osobiste',
  'shell.client.accountingClient': 'Klient księgowy',
  'shell.client.org': 'Nr org. {org}',
  'shell.suggest.invoices': 'Faktury',
  'shell.suggest.customers': 'Klienci',
  'shell.suggest.vouchers': 'Dokumenty',
  'trial.title': 'Okres próbny jest aktywny',
  'trial.active': 'Okres próbny jest aktywny.',
  'trial.dayLeft': 'Został Ci {days} dzień.',
  'trial.daysLeft': 'Pozostało dni: {days}.',
  'trial.body': 'Wszystko działa - miłego poznawania Plumme.',
  'trial.upgrade': 'Ulepsz plan',
  'home.greeting': 'Witaj ponownie 👋',
  'home.registerSale': 'Zarejestruj sprzedaż',
  'home.registerSaleHelp': 'Zarejestruj nową sprzedaż lub wystaw fakturę klientowi. Sprzedaż zostanie automatycznie zaksięgowana na właściwym koncie.',
  'home.registerPurchase': 'Zarejestruj zakup',
  'home.registerPurchaseHelp': 'Zarejestruj zakup lub wgraj dokument. SuperPlumma zaproponuje Ci konto i ujęcie VAT.',
  'home.aiHelp': 'Tutaj widzisz wszystko, co SuperPlumma i jego agenci zrobili automatycznie – księgowanie, VAT, płace i więcej. Zatwierdzasz jednym dotknięciem.',
  'home.autopilot.active': 'Aktywny',
  'home.autopilot.followUp': 'Wymaga uwagi',
  'home.autopilot.disabled': 'Wyłączony',
  'home.view.period': 'Okres',
  'home.view.analysis': 'Analiza',
  'home.view.cashflow': 'Wynik netto',
  'home.viewLabel.period': 'Przychody i koszty w miesiącach',
  'home.viewLabel.analysis': 'Podział przychodów i kosztów',
  'home.viewLabel.cashflow': 'Wynik netto w miesiącach',
  'home.ana.ring': 'Podział',
  'home.ana.gauge1': 'Wskaźniki',
  'home.ana.gauge2': 'Wskaźniki finansowe',
  'home.sub.yoyArrow': 'Strzałka pokazuje zmianę względem ubiegłego roku.',
  'home.sub.exVat': 'Wszystkie sumy są pokazywane bez VAT.',
  'home.legend.in': 'Wpływy',
  'home.legend.out': 'Wypływy',
  'home.legend.income': 'Przychód',
  'home.legend.cost': 'Koszt',
  'home.legend.result': 'Wynik',
  'home.legend.cashflow': 'Wynik',
  'home.selectedMonths': 'Wybrane miesiące:',
  'home.reset': 'Wyczyść',
  'home.sumOfMonth': 'Suma za {n} miesiąc',
  'home.sumOfMonths': 'Suma za miesiące (liczba: {n})',
  'home.noPrevPeriod': 'Brak poprzedniego okresu',
  'home.fromPrevMonth': 'względem poprzedniego miesiąca',
  'home.fromLastYear': 'względem ubiegłego roku',
  'home.showDistribution': 'Pokaż podział',
  'home.noData': 'Brak danych',
  'home.donut.registeredIncome': 'Zarejestrowane przychody',
  'home.donut.registeredCosts': 'Zarejestrowane koszty',
  'home.donut.income': 'Przychody',
  'home.donut.costs': 'Koszty',
  'home.donut.result': 'Wynik',
  'home.donut.breakdown': '{title} — podział',
  'home.donut.back': 'Wstecz',
  'home.donut.hint': 'Naciśnij część pierścienia lub kartę KPI poniżej, aby zobaczyć podział',
  'home.health.good': 'Dobra',
  'home.health.balanced': 'Zrównoważona',
  'home.health.weak': 'Słaba',
  'home.gauge.explain': 'Wyjaśnij wskaźnik',
  'home.gauge.currentValue': 'Bieżąca wartość',
  'home.gauge.assessment': 'Ocena',
  'home.gauge.goodLevel': 'Dobry poziom: {good}',
  'home.gauge.income': 'Przychody',
  'home.gauge.income.info': 'Przychody to suma wszystkiego, co firma sprzedała w okresie, bez VAT. Rosnące przychody w czasie dają większe pole manewru.',
  'home.gauge.income.good': 'Rosnące w czasie',
  'home.gauge.costs': 'Koszty',
  'home.gauge.costs.info': 'Koszty to wydatki potrzebne do prowadzenia firmy, bez VAT. Niższe koszty w stosunku do przychodów dają lepszy wynik.',
  'home.gauge.costs.good': 'Niższe niż przychody',
  'home.gauge.result': 'Wynik',
  'home.gauge.result.info': 'Wynik to to, co zostaje po odjęciu kosztów od przychodów. Dodatni wynik oznacza zysk w okresie.',
  'home.gauge.result.good': 'Dodatni i stabilny',
  'home.gauge.liquidity': 'Płynność',
  'home.gauge.liquidity.info': 'Płynność pokazuje zdolność do płacenia rachunków i zobowiązań krótkoterminowych w terminie. Wyższa wartość daje lepszy bufor.',
  'home.gauge.liquidity.good': 'Powyżej 1,0x, najlepiej powyżej 2,0x',
  'home.gauge.profitability': 'Rentowność',
  'home.gauge.profitability.info': 'Rentowność pokazuje, jaka część przychodów zostaje jako wynik. Im wyższy procent, tym więcej firma zarabia na każdej sprzedanej koronie.',
  'home.gauge.profitability.good': 'Dodatnia i rosnąca',
  'home.gauge.solidity': 'Wypłacalność',
  'home.gauge.solidity.info': 'Wypłacalność pokazuje, jaka część firmy jest finansowana kapitałem własnym. Wyższa wypłacalność czyni firmę bardziej odporną.',
  'home.gauge.solidity.good': 'Rosnący udział kapitału własnego w czasie',
  'home.assistant.sub': 'Asystent księgowy',
  'home.assistant.intro': 'Cześć! Mogę wykonywać za Ciebie proste czynności, tworzyć faktury, rejestrować zakupy, wyjaśniać opłaty i księgować dokumenty ze skrzynki odbiorczej. Pytaj śmiało. Jeśli chcesz porady finansowej, doradca jest dostępny na stronie AI Doradca.',
  'home.assistant.thinking': 'SuperPlumma myśli...',
  'home.assistant.placeholder': 'Zapytaj SuperPlummę...',
  'home.assistant.noReply': 'SuperPlumma nie otrzymała odpowiedzi z backendu.',
  'home.assistant.errorReply': 'Nie udało się teraz pobrać odpowiedzi asystenta.',
  'home.assistant.errorToast': 'Nie udało się pobrać odpowiedzi asystenta.',
  'home.assistant.cancel': 'Anuluj',
  'home.assistant.opened': 'Otworzyłam właściwą stronę z propozycją gotową do sprawdzenia.',
  'home.assistant.openedToast': 'Otwarto właściwy proces',
  'home.assistant.noAdapter': 'Ta czynność nie ma jeszcze adaptera Plumme.',
  'home.assistant.paymentNotConnected': 'Rejestracja płatności nie jest połączona z backendem.',
  'home.assistant.paymentRegistered': 'Płatność w wysokości {sum} została zarejestrowana na fakturze{number}.',
  'home.assistant.paymentToast': 'Płatność zarejestrowana',
  'home.assistant.paymentFailed': 'Nie udało się zarejestrować płatności.',
  'home.assistant.cancelled': 'W porządku, nic nie zmieniłam.',
  'home.assistant.sugg1': 'Ile jestem winien z tytułu opłat?',
  'home.assistant.sugg2': 'Utwórz fakturę dla klienta',
  'home.assistant.sugg3': 'Co to jest VAT?',
  'home.action.register_payment': 'Zatwierdź płatność',
  'home.action.create_invoice': 'Otwórz szkic faktury',
  'home.action.create_other_sale': 'Otwórz inną sprzedaż',
  'home.action.create_expense': 'Otwórz nowy zakup',
  'home.action.register_purchase': 'Otwórz nowy zakup',
  'home.action.create_customer': 'Zapisz klienta',
  'home.action.create_supplier': 'Zapisz dostawcę',
  'home.action.create_product': 'Zapisz produkt',
  'home.action.suggest_accounting_entry': 'Otwórz dowolne księgowanie',
  'home.action.create_mileage_entry': 'Otwórz ewidencję przebiegu',
  'home.action.send_sales_document': 'Otwórz listę faktur',
  'home.action.book_bank_lines': 'Otwórz bank',
  'home.action.link_bank_receipts': 'Otwórz bank',
  'home.action.annul_bank_posting': 'Otwórz bank',
  'home.action.reporting_preparation': 'Otwórz zgłoszenia',
  'home.action.default': 'Otwórz proces',
  'home.followup.title': 'Do zrobienia',
  'home.followup.allClear': 'Wszystko pod kontrolą',
  'home.followup.allClearSub': 'W tej chwili nie ma nic do zrobienia. Plumme da znać, gdy coś będzie wymagało uwagi.',
  'home.followup.next': 'Dalej',
  'home.followup.showMore': 'Pokaż więcej',
  'home.followup.modalTitle': 'Zadania do rozwiązania',
  'home.followup.sales': 'Sprzedaż',
  'home.followup.purchases': 'Zakupy',
  'home.followup.toInvoiceList': 'Przejdź do listy faktur',
  'home.followup.toVoucherList': 'Przejdź do listy dokumentów',
  'home.followup.draftInvoices': 'Niedokończone szkice faktur: {n}.',
  'home.followup.unsentInvoices': 'Faktury gotowe, ale niewysłane: {n}.',
  'home.followup.overdueInvoices': 'Nierozliczone przeterminowane faktury: {n}.',
  'home.followup.openPurchases': 'Nierozliczone faktury dostawców: {n}.',
  'home.followup.missingAttachments': 'Zakupy bez dokumentu: {n}.',
  'home.followup.bank': 'Uzgodnienie bankowe',
  'home.followup.toBank': 'Przejdź do uzgodnienia bankowego',
  'home.followup.missingBankStatements': 'Brak wyciągu bankowego dla rachunku firmowego za {months}',
  'home.overview.sales': 'Sprzedaż',
  'home.overview.purchases': 'Zakupy',
  'home.overview.outstandingSales': 'Nieopłacona sprzedaż',
  'home.overview.outstandingPurchases': 'Nieopłacone zakupy',
  'home.overview.salesHelp': 'Nieopłacona sprzedaż to faktury, których Twoi klienci jeszcze nie zapłacili. Zielony oznacza przed terminem, żółty po terminie — wyślij monit do przeterminowanych.',
  'home.overview.purchasesHelp': 'Nieopłacone zakupy to faktury dostawców, których jeszcze nie zapłaciłeś. Zielony oznacza przed terminem, żółty po terminie — należy je wkrótce zapłacić.',
  'home.overview.importedSubledger': 'W tym zaimportowane rozrachunki: {amount}',
  'home.overview.inclVat': 'Kwoty zawierają VAT.',
  'home.overview.helpTitle': 'Nieopłacone: {what}',
  'home.overview.withinDue': 'Przed terminem',
  'home.overview.overdue': 'Przeterminowane',
  'home.overview.statusTitle': '{within} % przed terminem · {over} % przeterminowane',
  'home.deadlines.title': 'Nadchodzące terminy',
  'home.deadlines.help': 'Nadchodzące terminy złożenia - MVA-melding, skattemelding, sprawozdanie finansowe i aksjonærregisteroppgave, ze statusem każdego z nich.',
  'home.deadlines.none': 'Nie znaleziono terminów w danych backendu.',
  'home.deadlines.seeStatus': 'Zobacz status',
  'home.deadlines.helpTax': 'Skattemelding zbiera księgowość i obliczenie podatku za rok. Plumme pomaga sprawdzić dane przed złożeniem.',
  'home.deadlines.helpAnnualAccounts': 'Sprawozdanie finansowe zbiera rachunek zysków i strat, bilans i noty za rok obrotowy i jest przesyłane do Regnskapsregisteret, gdy jest gotowe.',
  'home.deadlines.helpAnnualClosing': 'Zamknięcie roku zamyka rok obrotowy kontrolami, podziałem wyniku i niezbędnymi księgowaniami zamykającymi.',
  'home.deadlines.helpShareholderRegister': 'Aksjonærregisteroppgave (RF-1086) składają spółki akcyjne do 31 stycznia roku następującego po roku podatkowym. Plumme nie umożliwia jej złożenia — to jest przypomnienie.',
  'home.deadlines.helpVat': 'MVA-melding raportuje VAT należny i naliczony za okres.',
  'home.deadlines.helpFallback': 'Termin dla: {name}. Plumme powiadomi Cię i pomoże dalej w widoku statusu.',
  'home.deadlines.fallbackName': 'złożenie',
  'home.deadlines.name.shareholderRegister': 'Aksjonærregisteroppgave',
  'home.fees.title': 'Opłaty publiczne',
  'home.fees.help': 'Przegląd tego, ile jesteś teraz winien państwu - podatek od towarów i usług (VAT), zaliczka na podatek i składka pracodawcy. Obliczane na bieżąco na podstawie księgowości.',
  'home.fees.none': 'Nie znaleziono otwartych opłat publicznych.',
  'home.balances.title': 'Salda',
  'home.balances.help': 'Zaksięgowane salda na kontach bankowych, kasowych i innych. Dane pochodzą z zestawienia obrotów i sald, więc pokazują to, co mówi księgowość - a nie to, co bank zdążył zaktualizować. Kołem zębatym wybierasz, które konta są widoczne, i możesz wyszukać kolejne w planie kont. Rachunek firmowy i kasę można ukryć, ale nie usunąć.',
  'home.balances.choose': 'Wybierz konta',
  'home.balances.total': 'Razem',
  'home.balances.accountFallback': 'Konto {code}',
  'home.balances.noneSelected': 'Nie wybrano kont.',
  'home.balances.searchPlaceholder': 'Szukaj w planie kont …',
  'home.balances.noHits': 'Brak wyników',
  'home.balances.remove': 'Usuń z karty',
  'home.balances.saveFailed': 'Nie udało się zapisać wyboru kont.',
  'set.account': 'Konto',
  'set.amount': 'Kwota',
  'set.page': 'Strona',
  'set.debit': 'Wn',
  'set.credit': 'Ma',
  'set.remove': 'Usuń',
  'set.ib.title': 'Bilans otwarcia',
  'set.ib.startWizard': 'Uruchom kreator, aby utworzyć bilans otwarcia',
  'set.ib.confirmDate': 'Potwierdź datę rozpoczęcia',
  'set.ib.setUp': 'Skonfiguruj bilans otwarcia',
  'set.ib.confirmDateInPlumme': 'Potwierdź datę rozpoczęcia w Plumme',
  'set.ib.startDate': 'Data rozpoczęcia',
  'set.back': 'Wstecz',
  'set.ib.dateOk': 'Data się zgadza, dalej',
  'set.ib.draftEmpty': 'Szkic jest pusty.',
  'set.text': 'Tekst',
  'set.toDebit': 'Na (Wn)',
  'set.fromCredit': 'Z (Ma)',
  'set.editLine': 'Edytuj pozycję',
  'set.removeLine': 'Usuń pozycję',
  'set.quickPick': 'Szybki wybór',
  'set.addNewLine': 'Dodaj nową pozycję',
  'set.saved': 'Zapisano',
  'set.startOver': 'Zacznij od nowa',
  'set.ib.finish': 'Zakończ bilans otwarcia',
  'set.ib.summary': 'Podsumowanie - kwoty na konta i z kont',
  'set.ib.openNote': 'Księgowanie jest otwarte i można je zmienić w tym widoku.',
  'set.ib.intoAccount': 'Na konto',
  'set.ib.outOfAccount': 'Z konta',
  'set.sum': 'Suma',
  'set.ib.openEntry': 'Otwarte księgowanie',
  'set.accountNo': 'Nr konta',
  'set.name': 'Nazwa',
  'set.vatCode': 'Kod VAT',
  'set.description': 'Opis',
  'set.relevantLinks': 'Przydatne linki',
  'set.deleteCancel': 'Usuń / anuluj',
  'set.ib.edit': 'Zmień bilans otwarcia',
  'set.ib.openingForAccount': 'Saldo otwarcia konta',
  'set.cancel': 'Anuluj',
  'set.save': 'Zapisz',
  'set.ib.postDescription': 'Opis pozycji',
  'set.pickAccount': 'Wybierz konto ...',
  'set.accountDebit': 'Konto (Wn)',
  'set.ib.cannotBeEmpty': 'Nie można utworzyć pustego bilansu otwarcia',
  'set.continueTitle': 'Kontynuować?',
  'set.ib.post': 'Zaksięguj bilans otwarcia',
  'set.ib.draftTitle': 'Szkic bilansu otwarcia',
  'set.ib.draftHelp': 'Wprowadź dane bilansowe z poprzedniego systemu, aby zestawienie obrotów i sald zaczynało się prawidłowo w Plumme.',
  'set.noteOptional': 'Notatka (opcjonalnie)',
  'set.notePh': 'Na przykład co zostało zaimportowane i od jakiej daty',
  'set.ib.lines': 'Pozycje bilansu',
  'set.ib.linesHelp': 'Dane bilansowe na dzień przejścia, w podziale na konta: aktywa, kapitał własny i zobowiązania ze starego systemu. Wprowadź jedną pozycję na konto, aby bilans zaczynał się w Plumme od prawidłowych danych.',
  'set.ib.addLine': 'Dodaj pozycję bilansu',
  'set.startup.title': 'Dane początkowe',
  'set.startup.introText': 'Użyj tego, jeśli przechodzisz do Plumme w trakcie roku {year}. Wprowadzasz dane VAT i wynikowe z poprzedniego systemu, aby raporty i skattemelding były prawidłowo kontynuowane od daty przejścia.',
  'set.startup.startWizard': 'Uruchom kreator, aby wprowadzić dane początkowe',
  'set.startup.stepDate': 'Data przejścia i VAT',
  'set.startup.stepLines': 'Sprzedaż i koszty',
  'set.startup.confirmTitle': 'Potwierdź datę przejścia i dotychczasowy VAT',
  'set.startup.linesTitle': 'Rozdziel dane sprzed {date}',
  'set.startup.save': 'Zapisz dane początkowe',
  'set.startup.receiptTitle': 'Dane początkowe na dzień {date}',
  'set.startup.receiptSub': 'Zapisano na potrzeby przejścia do Plumme',
  'set.startup.receiptLines': 'Zarejestrowane pozycje: {lines} - sprzedaż {sales} i koszty {costs}.',
  'set.startup.edit': 'Zmień dane początkowe',
  'set.transitionDate': 'Data przejścia',
  'set.transitionDateHelp': 'Data, w której przeszedłeś do Plumme. Dane początkowe obejmują okres od początku roku do tej daty, prowadzony w starym systemie.',
  'set.outputVatBefore': 'VAT należny przed rozpoczęciem',
  'set.outputVatBeforeHelp': 'VAT, który już naliczyłeś od sprzedaży w tym roku przed przejściem. Zostanie dodany do tegorocznych danych VAT, aby MVA-melding była prawidłowa.',
  'set.inputVatBefore': 'VAT naliczony przed rozpoczęciem',
  'set.inputVatBeforeHelp': 'VAT, który już zapłaciłeś od zakupów w tym roku (i możesz odliczyć), przed przejściem.',
  'set.salesByAccount': 'Sprzedaż w podziale na konta',
  'set.salesByAccountHelp': 'Przychody ze sprzedaży od początku roku, w podziale na konta przychodowe. Wprowadź jedną pozycję na konto sprzedaży, aby rachunek zysków i strat zaczynał się od prawidłowych danych.',
  'set.salesByAccountBefore': 'Sprzedaż w podziale na konta przed rozpoczęciem',
  'set.addSalesLine': 'Dodaj pozycję sprzedaży',
  'set.noSalesLines': 'Brak pozycji sprzedaży.',
  'set.costsByAccount': 'Koszty w podziale na konta',
  'set.costsByAccountHelp': 'Koszty od początku roku, w podziale na konta kosztowe. Wprowadź jedną pozycję na konto kosztowe, aby wynik był prawidłowy od daty przejścia.',
  'set.costsByAccountBefore': 'Koszty w podziale na konta przed rozpoczęciem',
  'set.addCostLine': 'Dodaj pozycję kosztów',
  'set.noCostLines': 'Brak pozycji kosztów.',
  'set.import.title': 'Importuj pełną księgowość',
  'set.import.pickPackage': 'Wybierz pliki eksportu',
  'set.import.shouldContain': 'Pakiet powinien zawierać',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Rejestr klientów i dostawców, najlepiej w Excelu lub CSV',
  'set.import.chart': 'Plan kont',
  'set.import.vouchers': 'Dowody księgowe, paragony i faktury jako PDF lub obrazy',
  'set.import.bankRecs': 'Uzgodnienia bankowe i kopie faktur',
  'set.import.firstStep': 'Pierwszy krok w Plumme',
  'set.import.readsStructure': 'Odczytuje strukturę plików',
  'set.import.findsFiles': 'Znajduje pliki SAF-T, Excel i dowody księgowe',
  'set.import.buildsAnalysis': 'Tworzy analizę importu',
  'set.import.letsApprove': 'Pozwala zatwierdzić bezpieczny import planu kont, klientów, dostawców i bilansu otwarcia',
  'set.import.notAutomatic': 'Jeszcze nie automatycznie',
  'set.import.noPromise': 'Plumme nie obiecuje, że wszystko będzie dokładnie takie samo jak w poprzednim systemie',
  'set.import.noHistoric': 'Historyczne księgowania nie są księgowane bez zatwierdzenia',
  'set.import.nothingToAltinn': 'Nic nie jest wysyłane do Altinn',
  'set.import.noOverwrite': 'Istniejące dowody księgowe nie są usuwane ani nadpisywane bez potwierdzenia',
  'set.close': 'Zamknij',
  'set.import.approveBase': 'Zatwierdź import danych podstawowych',
  'set.import.working': 'Przetwarzanie...',
  'set.import.uploading': 'Przesyłanie do Firebase Storage',
  'set.import.serverReading': 'Serwer odczytuje teraz pliki importu',
  'set.import.importingBase': 'Importowanie danych podstawowych',
  'set.import.savedInAccounts': 'Import został zapisany w księgach',
  'set.import.checkBefore': 'Sprawdź plan kont, klientów, dostawców i bilans otwarcia przed raportowaniem.',
  'set.import.dataOnlyTitle': 'Importuj tylko dane księgowe (zalecane)',
  'set.import.dataOnlyHelp': 'Plumme tworzy w przeglądarce przefiltrowaną kopię z plikami SAF-T, CSV i Excel. Pliki PDF, obrazy i inne dokumenty nie są przesyłane.',
  'set.import.dataOnlyKeepOriginal': 'Zachowaj oryginalny plik ZIP z Fiken.',
  'set.import.dataOnlyFiltering': 'Usuwanie dokumentów przed przesłaniem',
  'set.import.dataOnlyFilteringHelp': 'Oryginalny plik nie zostaje zmieniony. Do Plumme wysyłany jest tylko nowy, przefiltrowany pakiet danych.',
  'set.import.dataOnlyFiltered': 'Pliki dokumentów i dowodów księgowych pominięte przy przesyłaniu: {count}.',
  'set.import.dataOnlyLibraryFailed': 'Nie udało się wczytać filtra ZIP. Spróbuj ponownie lub rozpakuj pliki SAF-T, CSV i Excel ręcznie.',
  'set.import.dataOnlyNoFiles': 'W pakiecie ZIP nie znaleziono plików SAF-T, CSV ani Excel.',
  'set.import.packages.title': 'Zapisane pakiety importu',
  'set.import.packages.help': 'Tutaj widzisz wszystkie pliki ZIP oraz to, który pakiet jest aktywnym źródłem archiwum importu.',
  'set.import.packages.loading': 'Wczytywanie pakietów...',
  'set.import.packages.empty': 'Brak zapisanych plików ZIP.',
  'set.import.packages.statusImported': 'Aktywny import',
  'set.import.packages.statusDuplicate': 'Identyczny duplikat',
  'set.import.packages.statusPrevious': 'Wcześniejszy import',
  'set.import.packages.statusAnalyzed': 'Odczytano',
  'set.import.packages.statusFailed': 'Odczyt nie powiódł się',
  'set.import.packages.statusAnalyzing': 'Odczytywanie',
});
